export const ANGGOTA = {
  STATUS_EDIT_ANGGOTA: {
    PENDING: 0,
    APPROVED: 1,
    REJECTED: 2,
  },
  STATUS_VERIFIKASI_ANGGOTA: {
    PENDING: 0,
    VERIFIED: 1,
    REJECTED: 2,
  },
}